import req from "@/assets/js/axios"
  /* 成果中心*/
export default {

  // 成果列表
  getAchievements: (params) => {
    return req.apiAxios("POST", '/sctccHost/achievement/AchievementController/getAchievements', params)
  },
  // 条件查询成果
  getHotAchievement: (params) => {
    return req.apiAxios("POST", '/sctccHost/achievement/AchievementController/getHotAchievement', params)
  },
  //条件查询用户关注成果（前台）
  getUserAchievements: (params) => {
    return req.apiAxios("POST", '/sctccHost/intermediate/userfollow/userachievement/UserAchievementController/getUserAchievements', params)
  },
  //添加用户关注成果
  createUserAchievement: (params) => {
    return req.apiAxios("POST", '/sctccHost/intermediate/userfollow/userachievement/UserAchievementController/createUserAchievement', params)
  },
   //删除用户关注成果
   deleteUserAchievement: (params) => {
    return req.apiAxios("POST", '/intermediate/userfollow/userachievement/UserAchievementController/deleteUserAchievement', params)
  },
}
